import { ChangeEvent, useEffect, useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
// import dayjs, { Dayjs } from "dayjs";
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { BACKGROUND } from '../../../shared/Helpers/colors';
import { EditSvg } from '../../../shared/Assets/svgIcons';
import { errorNormalizer } from '../../../shared/Helpers/functions';
import { CustomButton, CustomInput, Text } from '../../../shared/uiComponents';
import { ButtonWrapper } from '../../../components/StyledComponents';
import DeleteAllocation from './deleteAllocation';
// import { TimeInputsWrapper } from "../Reports/helpers";

import { DispatchProperties } from '../../../redux/store';
import { CreateUserSessionAllocationProperties } from '../../../redux/API/userAPIProperties';
import {
	createUserSessionAllocation,
	getUserActiveAllocations,
	updateUserSessionAllocation,
} from '../../../redux/State/userSlice';

const Content = ({ onClose }: { onClose: () => void }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const { userId } = useParams();

	// const [startDateValue, setStartDateValue] = useState<Dayjs | null>(null);
	// const [endDateValue, setEndDateValue] = useState<Dayjs | null>(null);
	const [hoursPerMonth, setHoursPerMonth] = useState<number>(0);
	const [loading, setLoading] = useState(false);
	const [hasActiveAllocation, setHasActiveAllocation] = useState(false);
	const [allocationId, setAllocationId] = useState<string | null>(null);

	const handleSave = () => {
		if (!hoursPerMonth || !userId) return;
		setLoading(true);

		const data: CreateUserSessionAllocationProperties = {
			// startDate: dateNormalizer(startDateValue),
			// endDate: dateNormalizer(endDateValue),
			hoursPerMonth,
			userId,
			sessionType: 9,
			frequency: 1,
		};
		dispatch(createUserSessionAllocation(data))
			.then(unwrapResult)
			.then(() => {
				toast('Success');
				onClose();
			})
			.catch(errorNormalizer)
			.finally(() => setLoading(false));
	};

	const handleUpdate = () => {
		if (!hoursPerMonth || !userId || !allocationId) return;
		setLoading(true);

		const data: CreateUserSessionAllocationProperties = {
			// startDate: dateNormalizer(startDateValue),
			// endDate: dateNormalizer(endDateValue),
			hoursPerMonth,
			userId,
			sessionType: 9,
			frequency: 1,
		};
		dispatch(updateUserSessionAllocation({ id: allocationId, data }))
			.then(unwrapResult)
			.then(() => {
				toast('Success');
				onClose();
			})
			.catch(errorNormalizer)
			.finally(() => setLoading(false));
	};

	// const startDateHandler = (date: Dayjs | null) => {
	//   setStartDateValue(date);
	// };

	// const endDateHandler = (date: Dayjs | null) => {
	//   setEndDateValue(date);
	// };

	const hoursPerMonthHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const value = event.target.valueAsNumber;
		if (value < 0) return;
		setHoursPerMonth(value);
	};

	useEffect(() => {
		if (!userId) return;
		dispatch(getUserActiveAllocations(userId))
			.then(unwrapResult)
			.then((response) => {
				const currentAllocation = response.find((allocation) => allocation.isActive);
				setHasActiveAllocation(Boolean(currentAllocation));
				if (!currentAllocation) return;
				// setStartDateValue(dayjs(currentAllocation.startDate));
				// setEndDateValue(dayjs(currentAllocation.endDate));
				setHoursPerMonth(currentAllocation.hoursPerMonth);
				setAllocationId(currentAllocation.id);
			});
	}, [userId, dispatch]);

	const label = hasActiveAllocation
		? 'Active Allocation Exists'
		: 'Please enter the allocation period and monthly hours.';

	return (
		<div style={{ display: 'flex', flexDirection: 'column' }}>
			<Text title={label} type="h6" fontWeight="semiBold" className="marginBottom16" />
			{/* <TimeInputsWrapper>
        <Picker.CustomDate label="Start Date" value={startDateValue} onChange={startDateHandler} />

        <Picker.CustomDate
          label="End Date"
          value={endDateValue}
          onChange={endDateHandler}
          disablePast={true}
        />
      </TimeInputsWrapper> */}

			<CustomInput
				label="Hours Per Month"
				type="number"
				value={hoursPerMonth}
				onChange={hoursPerMonthHandler}
				className="marginBottom16"
			/>

			<ButtonWrapper>
				<CustomButton title="Cancel" onClick={() => onClose()} buttonType="secondary" disabled={loading} />
				{hasActiveAllocation ? (
					<CustomButton
						title="Update"
						onClick={handleUpdate}
						loading={loading}
						disabled={!hoursPerMonth || !userId}
						startIcon={<EditSvg color={BACKGROUND.PRIMARY[100]} />}
					/>
				) : (
					<CustomButton title="Save" onClick={handleSave} loading={loading} disabled={!hoursPerMonth || !userId} />
				)}
				{hasActiveAllocation && <DeleteAllocation onClose={onClose} allocationId={allocationId} />}
			</ButtonWrapper>
		</div>
	);
};

export default Content;
